import React from 'react';
import {translate} from 'react-i18next';
import ReactDOM from 'react-dom';
import moment from 'moment/moment';
import * as photosService from './services/photos';
import IndexPlayer from './IndexPlayer';

const modalRoot = document.getElementById('modal-root');

class PhotoView extends React.PureComponent {

    constructor(props) {

        super(props);

        this.el = document.createElement('div');

        this.handleCloseClick = this.handleCloseClick.bind(this);
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
        this.handleDocumentKeyUp = this.handleDocumentKeyUp.bind(this);
        this.handleIndexChange = this.handleIndexChange.bind(this);
        this.handleRotateLeftClick = this.handleRotateLeftClick.bind(this);
        this.handleRotateRightClick = this.handleRotateRightClick.bind(this);
    }

    componentDidMount() {

        modalRoot.appendChild(this.el);
        document.addEventListener('keyup', this.handleDocumentKeyUp);
    }

    componentWillUnmount() {

        modalRoot.removeChild(this.el);
        document.removeEventListener('keyup', this.handleDocumentKeyUp);
    }

    getDisplayText() {

        const parts = [

            this.props.activePhoto.description ? `"${this.props.activePhoto.description}"` : null,
            this.props.activePhoto.tags.length > 0 ? this.props.activePhoto.tags.map(tag => `#${tag}`).join(', ') : null,
            moment.utc(this.props.activePhoto.time).local().format('D MMMM YYYY, HH:mm'),
        ];

        return parts.filter(x => x !== null).join(', ');
    }

    handleCloseClick() {

        if (this.props.onClose)
            this.props.onClose();
    }

    handleDeleteClick() {

        if (window.confirm(this.props.t('photoView.deleteConfirmation'))) {

            photosService.deleteById(this.props.activePhoto.id).then(() => {

                if (this.props.onDeletePhoto)
                    this.props.onDeletePhoto(this.props.activePhoto);

                this.handleCloseClick();
            });
        }
    }

    handleDocumentKeyUp(e) {

        if (e.keyCode === 27) { // Esc

            e.preventDefault();
            this.handleCloseClick();
        }
    }

    handleIndexChange(index) {

        if (this.props.onActivePhotoChange)
            this.props.onActivePhotoChange(this.props.photos[index]);
    }

    handleRotateLeftClick() {

        photosService.updateById(this.props.activePhoto.id, {rotate: -90}).then(() => {

            this.props.activePhoto.cacheBuster = new Date().getTime();
            this.forceUpdate(); // TODO: update other components currently displaying this photo.
        });
    }

    handleRotateRightClick() {

        photosService.updateById(this.props.activePhoto.id, {rotate: 90}).then(() => {

            this.props.activePhoto.cacheBuster = new Date().getTime();
            this.forceUpdate(); // TODO: update other components currently displaying this photo.
        });
    }

    render() {

        const contents = (

            <div className="photo-view d-flex flex-column bg-dark text-light">
                <nav className="navbar">

                    <span className="d-none d-sm-inline-block text-truncate mr-2" style={{flex: 1}}>{this.getDisplayText()}</span>

                    <div className="btn-group ml-auto">
                        <button type="button" className="btn btn-light" onClick={this.handleRotateRightClick}><i className="fas fa-redo"/></button>
                        <button type="button" className="btn btn-light" onClick={this.handleRotateLeftClick}><i className="fas fa-undo"/></button>
                        <button type="button" className="btn btn-light" onClick={this.handleDeleteClick}><i className="fas fa-trash"/></button>
                        <button type="button" className="btn btn-light" onClick={this.handleCloseClick}><i className="fas fa-times"/></button>
                    </div>

                    <span className="d-sm-none text-right text-truncate w-100 mt-2">{this.getDisplayText()}</span>

                </nav>
                <div className="container" style={{flex: 1, overflow: 'hidden' /* Not sure why, but this seems to be necessary. */}}>
                    <div className="row h-100">

                        <div className="col h-100 text-center">
                            <img src={this.props.activePhoto.filename} alt={this.props.activePhoto.description} className="img-thumbnail h-100" style={{objectFit: 'cover'}}/>
                        </div>

                    </div>
                </div>
                <nav className="navbar justify-content-center">

                    <IndexPlayer items={this.props.photos} index={this.props.photos.indexOf(this.props.activePhoto)} onIndexChange={this.handleIndexChange} playing={false}/>

                </nav>
            </div>
        );

        return ReactDOM.createPortal(contents, this.el);
    }
}

export default translate()(PhotoView);



// WEBPACK FOOTER //
// ./src/components/PhotoView.js